import React, { useState, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import LatexEditor from './LatexEditor';

const DragDropLatexEditor = ({ onImageDrop, onPaste, ...props }) => {
  const [isDragging, setIsDragging] = useState(false);
  const dragCounter = useRef(0);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current++;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      setIsDragging(true);
    }
  };

  const handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current--;
    if (dragCounter.current === 0) {
      setIsDragging(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    dragCounter.current = 0;

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      
      // Validate file type
      const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
      if (validTypes.includes(file.type)) {
        onImageDrop(file);
      } else {
        alert('Please drop a PNG or JPG image file');
      }
      
      e.dataTransfer.clearData();
    }
  };

  return (
    <Box
      onDragEnter={handleDragIn}
      onDragLeave={handleDragOut}
      onDragOver={handleDrag}
      onDrop={handleDrop}
      sx={{
        position: 'relative',
        height: '100%',
        ...(isDragging && {
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: alpha('#1976d2', 0.1),
            border: '2px dashed #1976d2',
            borderRadius: 1,
            zIndex: 10,
            pointerEvents: 'none',
          }
        })
      }}
    >
      <LatexEditor {...props} onPaste={onPaste} />
      
      {isDragging && (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 11,
            pointerEvents: 'none',
            textAlign: 'center',
            backgroundColor: 'background.paper',
            padding: 2,
            borderRadius: 1,
            boxShadow: 3,
          }}
        >
          <Typography variant="h6" color="primary">
            Drop image here
          </Typography>
          <Typography variant="body2" color="textSecondary">
            The image will be uploaded and LaTeX command inserted
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default DragDropLatexEditor;